import { timeout } from '@/src/compat/util';

import { ICampaignsService } from './ICampaignsService';

import {
  ICampaignActionsListPayload,
  ICampaignsActionsResponse,
  IEditActionPayload,
  IEditActionResponse,
} from '@/modules/CampaignsModule/interfaces/CampaignActions';
import {
  ICampaignDetailResponse,
  ICampaignListPayload,
  ICampaignsListResponse,
  ICampaignsStrategiesResponse,
  ICreateEditCampaigns,
  ICreateEditCampaignsResponse,
  TCampaignID,
} from '@/modules/CampaignsModule/interfaces/Campaigns';

export class StubCampaignsService implements ICampaignsService {
  static create(): ICampaignsService {
    return new StubCampaignsService();
  }

  /**
   * @param query: { campaign: ICreateEditCampaigns }
   * @returns {Promise<ICreateEditCampaignsResponse>}
   * @description Create new campaign
   */
  async createCampaign(query: {
    campaign: ICreateEditCampaigns;
  }): Promise<ICreateEditCampaignsResponse> {
    try {
      await timeout(2000);
      return { statusOK: true };
    } catch (error) {
      return { statusOK: false };
    }
  }

  /**
   * @param query: { campaign: ICreateEditCampaigns }
   * @returns {Promise<ICreateEditCampaignsResponse>}
   * @description Create new campaign
   */
  async getStrategiesByAccount(): Promise<ICampaignsStrategiesResponse> {
    try {
      await timeout(2000);
      return { statusOK: true, strategies: [] };
    } catch (error) {
      return { statusOK: false };
    }
  }

  /**
   * @param {}
   * @returns {Promise<any>}
   * @description Get list campaigns
   */
  async getCampaign(query: ICampaignListPayload): Promise<ICampaignsListResponse> {
    try {
      await timeout(2000);
      return { campaigns: [] };
    } catch (error) {
      return { statusOK: false };
    }
  }

  /**
   * @param {}
   * @returns {Promise<any>}
   * @description Get list campaigns
   */

  async getCampaignByID(campaignId: TCampaignID): Promise<ICampaignDetailResponse> {
    try {
      await timeout(2000);
      return { statusOK: false, campaign: {} };
    } catch (error) {
      return { statusOK: false, campaign: {} };
    }
  }

  //TODO: Next sprint implement search, filters & pagination
  async getActionsByCampaign(
    query: ICampaignActionsListPayload
  ): Promise<ICampaignsActionsResponse> {
    try {
      await timeout(2000);
      return { actions: [], total: 10, partial: 10 };
    } catch (error) {
      return { statusOK: false, actions: [] };
    }
  }

  async editAction(query: IEditActionPayload): Promise<IEditActionResponse> {
    try {
      await timeout(2000);
      return { statusOK: true };
    } catch (error) {
      return { statusOK: false };
    }
  }
}
